import React, { useMemo } from 'react';
import HarveyBallChart from './HarveyBallChart';
import { IWorkItem } from '../../interfaces/IWorkItemOverview';


interface IWorkItemInsightsProps {
  item: IWorkItem;
}

const WorkItemInsights: React.FC<IWorkItemInsightsProps> = ({ item }) => {
  const sortedInsights = useMemo(() => {
    return item?.insights?.sort((a, b) => b.weight - a.weight);
  }, [item?.insights]);

  return (
    <div>

      <ul className='list-none p-0 mb-2.5'>
        {sortedInsights?.map((insight, index) => (
          <li
            key={index}
            className='mb-2.5 p-2 bg-[#f9f9f9] rounded flex gap-2.5 text-base'
          >
            <span className={sortedInsights?.length > 1 ?'w-[82%]':'' }>{insight.description}</span>
            <div>
              {sortedInsights?.length > 1 &&
                <HarveyBallChart percentage={insight?.weight} />}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};


export default WorkItemInsights;